import { Routes } from '@angular/router';
import { Landing } from './components/landing/landing';
import { Testimonials } from './components/testimonials/testimonials';

export const routes: Routes = [
    { path: '', component: Landing },
    { path: 'Testimonials', component: Testimonials },
];
